import { useEffect, useRef } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { pageViewEvent } from '@kuow/core';
import { PublicShell } from './components/Shell/PublicShell';
import { RequireAuth } from './components/RequireAuth';
import { DonatePage } from './pages/DonatePage';
import { ReceiptPage } from './pages/ReceiptPage';
import { SignInPage } from './pages/SignInPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { MagicLinkExchangePage } from './pages/MagicLinkExchangePage';
import { UpdateBillingPage } from './pages/UpdateBillingPage';
import { UpdateDonationPage } from './pages/UpdateDonationPage';
import { MembersProfilePage } from './pages/MembersProfilePage';
import { MemberReceiptPrintPage } from './pages/MemberReceiptPrintPage';

function PageViewTracker() {
  const { pathname, search } = useLocation();
  const lastPathRef = useRef<string | null>(null);
  useEffect(() => {
    const fullPath = pathname + search;
    if (lastPathRef.current === fullPath) return;
    lastPathRef.current = fullPath;
    pageViewEvent(fullPath);
  }, [pathname, search]);
  return null;
}

function App() {
  return (
    <>
      <PageViewTracker />
      <Routes>
        <Route element={<RequireAuth />}>
          <Route path="members/receipt/:eventId" element={<MemberReceiptPrintPage />} />
        </Route>
        <Route path="/" element={<PublicShell />}>
          <Route index element={<DonatePage />} />
          <Route path="donate" element={<DonatePage />} />
          <Route path="donate/:formSlug" element={<DonatePage />} />
          <Route path="receipt" element={<ReceiptPage />} />
          <Route path="update_billing" element={<UpdateBillingPage />} />
          <Route path="update_donation" element={<UpdateDonationPage />} />
          <Route path="update_donation/:slug" element={<UpdateDonationPage />} />
          <Route path="sign-in" element={<SignInPage />} />
          <Route path="sign-in/magic" element={<MagicLinkExchangePage />} />
          <Route path="reset-password" element={<ResetPasswordPage />} />
          <Route path="me" element={<Navigate to="/members/profile" replace />} />
          <Route path="members" element={<RequireAuth />}>
            <Route index element={<Navigate to="/members/profile" replace />} />
            <Route path="profile" element={<MembersProfilePage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
